var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSpotifyLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 18.71 12.19",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.76,11.75c-0.16,0.28-0.46,0.44-0.77,0.44c-0.15,0-0.31-0.04-0.45-0.12c-2.33-1.36-5.02-1.58-6.86-1.52 c-2.04,0.06-3.54,0.47-3.56,0.47c-0.47,0.13-0.96-0.15-1.09-0.62C1.91,9.93,2.19,9.44,2.66,9.31c0.07-0.02,1.68-0.46,3.93-0.53 c1.32-0.04,2.59,0.05,3.78,0.27c1.5,0.29,2.88,0.79,4.08,1.49C14.86,10.79,15.01,11.33,14.76,11.75z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.41,8.33c-0.19,0.33-0.55,0.52-0.91,0.52c-0.18,0-0.36-0.05-0.53-0.14c-2.76-1.61-5.94-1.87-8.13-1.8 c-2.42,0.07-4.2,0.55-4.22,0.56C2.07,7.62,1.49,7.29,1.34,6.73C1.19,6.17,1.51,5.59,2.07,5.44C2.15,5.42,4.06,4.9,6.72,4.81 c1.57-0.05,3.07,0.06,4.48,0.32c1.78,0.34,3.41,0.93,4.83,1.76C16.53,7.19,16.7,7.83,16.41,8.33z",
    fill: "currentColor"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M17.42,5.23c-0.22,0-0.44-0.06-0.65-0.18C10.22,1.22,1.72,3.5,1.63,3.52c-0.69,0.19-1.39-0.21-1.58-0.9 c-0.19-0.69,0.21-1.39,0.9-1.58c0.1-0.03,2.44-0.66,5.7-0.77c1.92-0.06,3.77,0.07,5.49,0.4c2.18,0.41,4.18,1.14,5.92,2.16 c0.61,0.36,0.82,1.15,0.46,1.76C18.29,5,17.86,5.23,17.42,5.23z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpotifyLogo);
export default __webpack_public_path__ + "static/media/spotify-logo.f1c6e239e08774c5afdc89cf371e95fa.svg";
export { ForwardRef as ReactComponent };